var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill-progress"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('b-progress',{attrs:{"max":_vm.max}},[_c('b-progress-bar',{attrs:{"value":_vm.value}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }